import { render } from "./GenreListing.vue?vue&type=template&id=3944997b"
import script from "./GenreListing.vue?vue&type=script&lang=js"
export * from "./GenreListing.vue?vue&type=script&lang=js"
script.render = render

export default script